import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import Typography from "aldoo-ra/Typography"

const HeaderRating = () => {
  return (
    <div className="flex w-full justify-start items-center lg:flex-row flex-col mx-auto">
      {/* Content Section for Header Rating */}
      <CMSRender
        contentType="Icon"
        match={{ "content.id": "HomeHeaderRating" }}
        renderItem={(data, id) => {
          return (
            <div key={id} className="flex items-center justify-center lg:justify-start gap-4 w-full lg:w-auto">
              {/* Single Image for Five Stars */}
              <img
                src={data.image}
                alt="Five-star rating"
                className="w-24 h-auto object-contain"
              />

              {/* Title */}
              <Typography variant="body1" className="my-0">
                <span dangerouslySetInnerHTML={{ __html: data.title }} />
              </Typography>
            </div>
          )
        }}
      />
    </div>
  )
}

export default HeaderRating
